'use strict';
module.exports = require('../../full/symbol/to-string-tag');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/symbol/to-string-tag.js
// module id = 616
// module chunks = 13